import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import MechanismSection from './components/MechanismSection';
import WinnersSection from './components/WinnersSection';
import RulesAndContact from './components/RulesAndContact';
import './App.scss';
// import BottomSection from './components/BottomSection';
import ScoreChecker from './components/ScoreChecker';
import EndGame from './components/EndGame';
import CodeForm from './components/CodeForm';
import Quiz from './components/Quiz';
import AdminRoute from './components/AdminRoute';


const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <NavigationBar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <section id="mehanizam">
                  <MechanismSection />
                </section>
                {/* StartQuiz se NE prikazuje na običnom home page-u */}
                {/* <LineBackgroundSection /> */}
                <section id="lista-dobitnika">
                  <WinnersSection />
                </section>
                {/* <LineBackgroundSection /> */}
                <section id="pravila-kontakt">
                  <RulesAndContact />
                </section>
                {/* <section id="zapocni-kviz">
                  <BottomSection />
                </section> */}
              </>
            }
          />
          <Route path="/prijava" element={<CodeForm />} />
          <Route path="/prijava/:code" element={<CodeForm />} />
          <Route path="/kviz" element={<Quiz />} />
          <Route path="/proveri-skor" element={<ScoreChecker />} />
          <Route path="/kraj" element={<EndGame />} />
          {/* Admin ruta - Validira kod i prikazuje StartQuiz ako je validan */}
          <Route path="/:adminCode" element={<AdminRoute />} />
        </Routes>
      </div>
    </Router>
  );
};


export default App;
